// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { type MutateOptions, useMutation } from '@tanstack/react-query'

import { type Coverage } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type CoveragesPatchParam = {
  start_date?: string;
  end_date?: boolean;
  coverage_audit_reason: string;
}

export type CoveragesMutateOptions = MutateOptions<Coverage[], GrapeAPIErrorType, CoveragesPatchParam, unknown> | undefined

export function useModifyCoverages ({
  enrollmentId,
  memberId,
  coverageIds
}: {
  enrollmentId: string;
  memberId: string
  coverageIds: string[];
}) {
  return useMutation<Coverage[], GrapeAPIErrorType, CoveragesPatchParam>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'put',
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}/coverages`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            coverage_ids: coverageIds,
            ...params
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
